import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UserServiceService = /** @class */ (function () {
    function UserServiceService(http) {
        this.http = http;
    }
    UserServiceService.prototype.getLastLogin = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/users/last-login";
        return this.http.get(requestUrl)
            .pipe(map(function (res) { return res; }), catchError(function (httpError) { return _this.handleError(httpError); }));
    };
    UserServiceService.prototype.syncUsers = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/users/sync";
        return this.http.get(requestUrl)
            .pipe(map(function (res) { return res; }), catchError(function (httpError) { return _this.handleError(httpError); }));
    };
    UserServiceService.prototype.handleError = function (httpError) {
        var errorMessage = "An unknown error occurred while submitting the request";
        if (httpError.error && httpError.error.message) {
            errorMessage = httpError.error.message;
        }
        core.pageBanner.loadResponse(errorMessage, { title: "Error occurred", type: core.pageBanner.bannerTypes.error });
        return throwError(httpError);
    };
    UserServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserServiceService_Factory() { return new UserServiceService(i0.ɵɵinject(i1.HttpClient)); }, token: UserServiceService, providedIn: "root" });
    return UserServiceService;
}());
export { UserServiceService };
